import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
import ExpressionNode from './ExpressionNode';

var ExpressionTree = /*#__PURE__*/function () {
  function ExpressionTree(expressionTree) {
    if (expressionTree) {
      this._root = new ExpressionNode(expressionTree.root);
    }
  }

  var _proto = ExpressionTree.prototype;

  _proto.getExpressionTreeObjectification = function getExpressionTreeObjectification() {
    var ret = {};

    if (this._root) {
      ret.root = this._root.getExpressionNodeObjectification();
    }

    return ret;
  };

  _createClass(ExpressionTree, [{
    key: 'root',
    get: function get() {
      return this._root;
    }
  }]);

  return ExpressionTree;
}();

export { ExpressionTree as default };